import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { BtnFactory, SIZE } from './BtnFactory';
export { SIZE };
export const TertiaryBtn = forwardRef(
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
(props, ref) => {
    return _jsx(BtnFactory, { ref: ref, as: 'button', severity: 'tertiary', ...props });
});
//# sourceMappingURL=TertiaryBtn.js.map